import axios from '@/plugins/axios'

// Tangkapan -> Sistem Analisis SSO (logic only; the view just calls this).
//
// Fetches a signed ticket from our backend GET /sso/go-analisis (the axios
// instance attaches the Bearer token), then auto-submits it as a POST form to
// Analisis so the ticket travels in the request body, not the URL. Analisis
// verifies the ticket and signs the user in.
//
// Throws on failure so the caller (a menu item) can surface a message.
export default async function openSistemAnalisis () {
  const res = await axios.get(`${process.env.VUE_APP_API_URL}/sso/go-analisis`)
  if (!res.data || !res.data.status || !res.data.ticket || !res.data.consumeUrl) {
    throw new Error((res.data && res.data.message) || 'Could not open Sistem Analisis.')
  }
  const { ticket, consumeUrl } = res.data
  const form = document.createElement('form')
  form.method = 'POST'
  form.action = consumeUrl
  const input = document.createElement('input')
  input.type = 'hidden'
  input.name = 't'
  input.value = ticket
  form.appendChild(input)
  document.body.appendChild(form)
  form.submit()
}
